// extracted by mini-css-extract-plugin
export default {"headerContainer":"header_headerContainer__ij0Ii","hidden":"header_hidden__Gdqni","logo":"header_logo__TmkQW","menu":"header_menu__LhfdJ"};